<template lang="pug">
.card-header.d-flex.align-items-center.bg-normal-head.collapse-head(
  v-if="source.ptype == 20"
  :id="source.id"
  :class="[source.marketId == 3 ? 'live ' + source.categoryId : [41, 42, 43, 44, 47].includes(source.sportsId) ? 'live ' + source.categoryId : source.categoryId, leagueKindClassOf(source.leagueId)]"
  data-toggle='collapse'
  :data-target="'#league-' + source.id"
)
  .mr-2
    img(:src="'/images/icon-sport-svg/' + getSportsImage(source.sportsId)" width='20' height='20')
  .bg-star(@click="xToggleFavs(source.matches, $event)" :class="fav == true ? 'active' : ''")
  .tag(v-if="leagueKindClassOf(source.leagueId)") {{ $t("ui.virtual") }}
  .league-title.flex-grow-1.text-uppercase(:class="['orz'].includes(menu3) ? 'league-title-orz' : menuY != 0 ? 'event' : ''")
    template(v-if="source.betTypeId != 'orz'")
      template(v-if="[40].includes(source.sportsId)") {{ $dayjs(source.lastMatchTime).format("MM/DD hh:mm A") }} {{ source.leagueName }}
      template(v-else) {{ source.leagueName }}
    template(v-else) [{{ $dayjs(source.lastMatchTime).format("MM/DD/YYYY") }}] {{ source.leagueName }}
  .tooltip(v-if="![40].includes(source.sportsId) && source.leagueInfo != null" @click="xToggleTooltips($event)")
    i.fal.fa-exclamation-circle
    .tooltiptext
      | {{ source.leagueInfo }}
  .btn-4d(v-if="special.includes(source.sportsId)")
    //- template(v-if="[41, 42, 43, 44, 45, 46, 47, 49, 51, 53].includes(source.sportsId)")
    //-   a(
    //-     :href="'/efresult?q=' + source.sportsId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) "
    //-     target="_blank"
    //-     onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
    //-   )
    //-     i.fas.fa-chart-bar
    template(v-if="[40].includes(source.sportsId)")
      a(
        :href="'/ngresult?q=' + source.leagueId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) + '&u=' + encodeURI(league()[source.leagueId][6])"
        target="_blank"
        onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
      )
        i.fas.fa-chart-bar
    template(v-else)
      a(
        :href="'/efresult?q=' + source.sportsId + '&n=' + encodeURI(league()[source.leagueId][4].replace('+', '$')) "
        target="_blank"
        onclick="window.open(this.href,'_blank','top=10,height=900,width=450,status=no,toolbar=no,menubar=no,location=no');return false;"
      )
        i.fas.fa-chart-bar
  .league-number(v-else) {{ source.matchList.length }}
</template>

<script>
import config from "@/config";
import mixinTypes from "@/library/mixinTypes";
import { EventBus } from "@/library/_event-bus.js";

export default {
  mixins: [mixinTypes],
  props: {
    source: {
      type: Object
    }
  },
  computed: {
    special() {
      return config.special;
    },
    // Derived rather than set in mounted(): league rows are reused across refreshes now, so a mount-time
    // flag would stop following changes to the favorite list or to the league's own match list
    fav() {
      if (this.menu0 == "favorite") {
        return true;
      }
      if (!this.favorite) {
        return false;
      }
      var items = this.source.matches;
      for (var n in items) {
        if (this.favorite.indexOf(items[n][2]) == -1) {
          return false;
        }
      }
      return true;
    },
    leagueKindColors() {
      return config.leagueKindColors;
    }
  },
  mounted() {
    $(".btn-4d").click(function(event){
      event.stopPropagation();
    });
  },
  methods: {
    league() {
      return this.$store.getters.data.league;
    },
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    xToggleTooltips(e) {
      // console.log("xToggleTooltips", e);
      e.stopPropagation();
    },
    xToggleFavs(items, e) {
      e.stopPropagation();
      var favList = [];
      for (var n in items) {
        favList.push(items[n][2]);
      }
      if (this.fav == false) {
        this.$store.dispatch("layout/setFavorite", favList);
      } else {
        this.$store.dispatch("layout/delFavorite", favList);
      }

      if (this.menu0 == "favorite") {
        EventBus.$emit("GET_MARKET");
      }
    },
    leagueKindClassOf(leagueId) {
      return this.$store.getters.leagueKindClassOf(leagueId);
    }
  }
}
</script>